export enum SamePathAppVersion {
    SPORTS_WEB_APP = 'SportsWebApp',
    SPORTS_BETSTATION_APP = 'SportsBetstationApp',
    CORAL_DESKTOP_APP = 'CoralDesktopApp',
    CORAL_MOBILE_APP = 'CoralMobileApp',
    LADBROKES_DESKTOP_APP = 'LadbrokesDesktopApp',
    LADBROKES_MOBILE_APP = 'LadbrokesMobileApp',
    GAMES = 'Games',
    CASINO = 'Casino',
    SLOTS = 'Slots',
    SPINS = 'Spins',
    DICE = 'Dice',
}
